export function stickyNav() {
    const header = $(".header");
    const headerHeight = header.innerHeight();
    const stickyArea = $(".sticky-area");
    const stickyNav = $('.aside-nav.sticky');
    const sections = $('[data-anchor-id], .anchored');
    const innerWraper = $('.inner-wrapper');
    let scrollTop;

    stickyNav.find('.has-anchor').each((i, link) => {
        $(link).on('click', function (e) {
            e.preventDefault();

            const target = $(link).attr("href").slice(1);

            if (target) {
                const anchoredBlock = $(`[data-anchor-id=${target}], #${target}`);

                if (anchoredBlock.length) {
                    $("html, body").animate({scrollTop: anchoredBlock.offset().top - headerHeight + 40}, 500);
                }
            }
        })
    });

    function sticky() {
        if (window.innerWidth > 1023) {
            scrollTop = $(window).scrollTop();
            const stickyAreaHeight = stickyArea.innerHeight();
            const stickyAreaTop = stickyArea.offset().top;
            const stickyAreaBottom = stickyAreaHeight + stickyAreaTop - headerHeight;

            if (scrollTop > stickyAreaTop - headerHeight && scrollTop < stickyAreaBottom - headerHeight) {
                stickyArea.addClass('has-fixed-child');
            } else if (scrollTop > stickyAreaBottom - headerHeight) {
                stickyArea.removeClass('has-fixed-child');
            } else {
                stickyNav.find('li').removeClass('active');
                stickyArea.removeClass('has-fixed-child');
            }


            if (stickyArea.hasClass('has-fixed-child')) {
                sections.each(function (index, section) {
                    const $this = $(section);
                    const itemOffsetTop = $this.offset().top;
                    const itemHeight = $this.outerHeight(true);
                    const attr = $this.attr('data-anchor-id') ? $this.attr('data-anchor-id') : $this.attr('id');
                    let sliderNavItem = stickyNav.find('a[href="#' + attr.toLowerCase() + '"]').parent();
                    if ((scrollTop + headerHeight - 30 >= itemOffsetTop) && (scrollTop <= itemOffsetTop + itemHeight)) {
                        if (!sliderNavItem.hasClass('active')) {
                            sliderNavItem.siblings().removeClass('active');
                            sliderNavItem.addClass('active');
                            $this.addClass('active');
                        }
                    } else {
                        $this.removeClass('active');
                    }
                })
            }
            if (innerWraper.length && stickyNav.css('display') !== 'none') {
                let h = stickyNav.innerHeight()
                innerWraper.css('margin-top', `-${h}px`);
            }
        } else {
            stickyArea.removeClass('has-fixed-child');
            if (innerWraper.length) {
                innerWraper.removeAttr('style');
            }
        }
        innerWraper.removeClass('load');
    }

    $(window).on("load scroll resize", function () {
        sticky();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/stickyNav.js